export default __webpack_public_path__ + "static/media/disBest.db23b970.svg";